import { render, staticRenderFns } from "./BInputGroupFormDatepicker.vue?vue&type=template&id=fd43fbe4&"
import script from "./BInputGroupFormDatepicker.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd43fbe4')) {
      api.createRecord('fd43fbe4', component.options)
    } else {
      api.reload('fd43fbe4', component.options)
    }
    module.hot.accept("./BInputGroupFormDatepicker.vue?vue&type=template&id=fd43fbe4&", function () {
      api.rerender('fd43fbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/forms/BInputGroupFormDatepicker.vue"
export default component.exports